import loadable from '@loadable/component';

const LazyTagSuggestions = loadable(() => import('./TagSuggestions'), {
    resolveComponent: (components: { TagSuggestions: React.ReactElement }) =>
        components.TagSuggestions,
});
const LazyFilterSuggestions = loadable(() => import('./FilterSuggestions'), {
    resolveComponent: (components: { FilterSuggestions: React.ReactElement }) =>
        components.FilterSuggestions,
});
const LazyEventSuggestions = loadable(() => import('./EventSuggestions'), {
    resolveComponent: (components: { EventSuggestions: React.ReactElement }) =>
        components.EventSuggestions,
});

export { LazyTagSuggestions as TagSuggestions };
export { LazyFilterSuggestions as FilterSuggestions };
export { LazyEventSuggestions as EventSuggestions };
